<template>
	<div>
		<div class="container">
			<div class="handle-box">
				<el-select v-model="query.companyId" placeholder="公司" clearable  class="handle-select mr10">
					<el-option v-for="item in companys" :label="item.companyName" :value="item.companyNo"></el-option>
				</el-select>
				<el-input v-model="query.name" style="width: 150px;" placeholder="角色名称" clearable  class="handle-input mr10"></el-input>
				<el-button type="primary" icon="el-icon-search" @click="clickSearch">搜索</el-button>
				<el-button type="primary" @click="showDialog(0)">添加</el-button>
			</div>
			<el-table :data="tableData" border>

				<el-table-column prop="companyName" label="所属公司"></el-table-column>
				<el-table-column prop="roleName" label="角色名称"></el-table-column>

				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button title="修改" v-if="scope.row.id!=1" plain icon="el-icon-edit" @click="showDialog(1,scope.row)" circle></el-button>
						<el-button title="删除" v-if="scope.row.id!=1" plain icon="el-icon-delete" @click="del(scope.row)" circle></el-button>
					</template>
				</el-table-column>
			</el-table>

			<div class="pagination">
				<el-pagination background layout="total, prev, pager, next" :current-page="query.pageIndex" :page-size="query.pageRows"
				 :total="pageTotal" @current-change="handlePageChange" prev-click="pageChange(1)" next-click="pageChange(2)"></el-pagination>
			</div>

		</div>

		<el-dialog :title="editType==0?'新增':'修改'" :visible.sync="showEdit" width="30%" :show-close="true" :close-on-click-modal="false">
			<el-dialog title="权限列表" :visible="showMenu" width="20%" :close-on-click-modal="false" destroy-on-close append-to-body>
				<div style="height: 280px;overflow-y: scroll">
					<el-tree :data="menus" ref="tree" :props="menuProps" :check-strictly="false"
							 show-checkbox node-key="id" :default-checked-keys="role.menuIds"></el-tree>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="closeMenu(0)">取消</el-button>
					<el-button @click="closeMenu(1)">确认选择</el-button>
				</span>
			</el-dialog>
			<el-form :model="role">
				<el-row :gutter="5">
					<el-col :span="12">
						<el-form-item label="所属公司">
							<el-select v-model="role.companyId" value-key="companyId" placeholder="选择公司">
								<el-option v-for="item in companys" :label="item.companyName" :value="item.companyNo"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="角色状态">
							<el-select v-model="role.isValid" placeholder="请选择">
								<el-option label="有效" :value="true"></el-option>
								<el-option label="无效" :value="false"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :span="12">
						<el-form-item label="角色名称">
							<el-input type="text" v-model="role.roleName" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="备注">
							<el-input type="text" v-model="role.remark" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="20">
					<el-col :span="24">
						<el-form-item label="授权">
							<el-button @click="showMenuDialog">选择权限</el-button>
						</el-form-item>
					</el-col>
				</el-row>

			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button @click="showEdit = false">取 消</el-button>

				<el-button type="primary" @click="submit">提交</el-button>
			</span>
		</el-dialog>




	</div>
</template>

<script>
	import {mapState} from 'vuex'
	export default {
		data: function() {
			return {
				query: {
					companyId: null,
					status: null,
					name: null,
					pageIndex: 1,
					pageRows: 10
				},
				tableData: [],
				pageTotal: 0,
				showEdit: false,
				editType: 0, //0添加 1修改
				showMenu: false,
				role: {
					id: '',
					companyId:'',
					menuIds: [],
					orgName: '',
					roleName: '',
					remark: '',
					isOpen: false,
					isValid: true
				},
				menuProps: {
					label: 'name',
					children: 'children',
					isLeaf: 'isParent'
				},
				checkedMenu: {},
				menus:[]
			}
		},
		computed:{
			...mapState(['companys']),
		},
		created() {
			this.handleSearch();
			this.loadMenu()
		},
		methods: {
			clickSearch: function() {
				this.query.pageIndex = 1;
				this.handleSearch();
			},
			handleSearch: function() {
				//查询
				this.HTTP.post('/system/role/queryPage', this.query).then(res => {

					if (res.data.code == 1) {
						this.tableData = res.data.rows
						this.pageTotal = res.data.counts
					}else{
						this.$message.error(res.data.message);
					}

				}).catch(err => {
					console.log(err)
				})
			},
			handlePageChange: function(e) {
				this.query.pageIndex = e
				this.handleSearch()
			},
			pageChange: function(type) {
				if (type == 1) {
					this.query.pageIndex -= 1;
				} else {
					this.query.pageIndex += 1;
				}
				this.handleSearch()
			},
			showDialog: function(type,data) {
				this.editType = type;
				this.showEdit = true;
				if (this.editType == 0){
					this.role = {};
				}else{
					this.role = data;
				}
			},
			del(data){
				this.$alert('请确定是否删除?', '确定删除', {
					confirmButtonText: '确定',
					callback: action => {
						this.role = {};
						this.role.id = data.id;
						this.role.isValid = false;
						this.postRole();
					}
				});

			},
			loadMenu(){
				this.HTTP.get('/system/menu/treeWithRole').then(res=>{
					if (res.data.success){
						this.menus = res.data.rows;
						for (let i in this.menus){
							if (this.menus[i].level==0){
								this.menus[i].disabled = true;
							}
						}

					}else{
						this.$message.error(res.data.message);
					}
				})
			},
			showMenuDialog(){
				this.showMenu = true;
				let $this = this;
				setTimeout(()=>{
					$this.setCheckedKeys(this.role.menuIds);
				},50)
			},
			closeMenu: function(type) {
				if (type==0){
					this.showMenu = false
					return
				}
				this.showMenu = false
				let menuIds = this.$refs.tree.getCheckedKeys();
				let halfcheck = this.$refs.tree.getHalfCheckedKeys();
				this.role.menuIds = menuIds;
				for (let i in halfcheck){
					let id = halfcheck[i];
					if (id.indexOf("-")<0){
						this.role.menuIds.push(halfcheck[i]);
					}
				}

			},
			submit(){
				debugger
				if (!this.role.roleName  ) {
					this.$message.error('请填写角色名');
					return
				}
				if (!this.role.menuIds || this.role.menuIds.length==0){
					this.$message.error('请选择权限');
					return
				}
				if (!this.role.companyId){
					this.$message.error('请选择所属公司');
					return
				}
				this.postRole();
			},
			postRole: function() {

				this.HTTP.post('/system/role/saveOrUpdate', this.role)
					.then(res => {
						if (res.data.code == 1) {
							this.showEdit = false
							this.$message.success("更新成功");
							this.handleSearch()
						} else {
							this.$message.error(res.data.message);
						}
					})
					.catch(err => {})
			},
			setCheckedKeys:function(menuIds) {
				var menuArr=[];
				for (let j = 0; j < menuIds.length; j++) {
					const menuid = menuIds[j];
					let key=this.getNodekeys(menuid,this.menus);
					if(key!=''){
						menuArr.push(key);
					}
				}
				this.$refs.tree.setCheckedKeys(menuArr);
			},
			//获取选中的孩子节点
			getNodekeys:function(menuId,childrens){
				var key="";
				for (let i = 0; i < childrens.length; i++) {
					const menu = childrens[i];
					let id=menu.id;
					let childs=menu.children;
					if(id==menuId){//如果相等
						if(childs&&childs.length>0){
							key=this.getNodekeys(menuId,childs)
						}else{  //没有孩子节点
							return menuId;
						}
					}else if(childs&&childs.length>0){
						key=this.getNodekeys(menuId,childs);
					}
					if(key!=''){
						return key;
					}
				}
				return key;
			},

		}
	}
</script>

<style>
	.handle-box {
		margin-bottom: 20px;
	}

	.mr10 {
		margin-right: 10px;
	}

</style>
